/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put } from 'redux-saga/effects'
import { createSagas } from 'src/helpers/redux'
import * as numberService from 'src/services/numbers'
import * as accountService from 'src/services/accounts'
import * as app from 'src/store/modules/app'
import { IConnectedAccount } from 'src/store/modules/account/state'

import { setters } from './index'
import { actions, Actions } from './actions'
import { IResponse } from 'src/services/accounts/http'

export default createSagas<Actions>(actions, {
  fetchMore: function* ({ payload }) {
    const accounts: IResponse<IConnectedAccount[]> = yield call(
      accountService.getAccounts,
      payload
    )

    yield put(setters.setFetchedMoreData(accounts))
  },
  getNumbers: function* ({ payload }) {
    const accounts: IResponse<IConnectedAccount[]> = yield call(
      accountService.getAccounts,
      payload
    )

    yield put(setters.setConnectedAccounts(accounts))
  },

  getAccount: function* ({ payload }) {
    const account: IResponse<accountService.IAccount> = yield call(
      accountService.getAccount,
      payload
    )

    yield put(setters.setAccountItem(account.data))
  },
  postAccountsUpdate: {
    pending: function* ({ payload }) {
      const accounts: IResponse<accountService.IAccount> = yield call(
        accountService.patchAccountsUpdate,
        payload
      )

      yield put(setters.setAccountsUpdate(accounts.data))

      yield put(
        app.actions.tost.pending({
          type: 'success',
          title: 'Account settings saved',
        })
      )
    },
  },
  deleteAccounts: function* ({ payload }) {
    const accounts: IResponse<void> = yield call(
      accountService.deleteAccounts,
      payload
    )

    yield put(setters.setAccountsDelete({ accountId: payload.accountId }))

    yield put(
      app.actions.tost.pending({
        type: 'success',
        title: 'Account removed',
      })
    )
  },
  getAvailableNumbersTwillio: function* ({ payload }) {
    const numbers: numberService.IGetAvailableNumbers = yield call(
      numberService.getAvailableNumbersTwillio,
      payload
    )

    yield put(setters.setAvailableNumbers(numbers.data))
  },
  getAvailableNumbersRc: function* () {
    const numbersRc = yield call(numberService.getAvailableNumbersRc)

    yield put(setters.setAvailableRcNumbers(numbersRc.data))
  },

  releaseNumber: function* ({ payload }) {
    yield call(numberService.releaseNumber, payload)

    yield put(setters.releaseNumber(payload.accountIds))
  },
  assigneRcNumber: function* ({ payload }) {
    const assignedNumber: IResponse<IConnectedAccount> = yield call(
      numberService.assigneRcNumber,
      payload
    )

    yield put(setters.setUpdateNumberState(assignedNumber.data))

    yield put(
      setters.removeAssignedNumber({ phoneNumber: payload.phoneNumber })
    )
  },
  assigneTwillioNumber: function* ({ payload }) {
    const assignedNumber: IResponse<IConnectedAccount> = yield call(
      numberService.assigneTwillioNumber,
      payload
    )

    yield put(setters.setUpdateNumberState(assignedNumber.data))

    yield put(
      setters.removeAssignedNumber({
        communicationNumber: payload.communicationNumber,
      })
    )
  },
})
